<template>
<md-list-item>
    <md-layout md-row>
        <md-layout md-flex="25">
            <md-checkbox v-model="layerPerms" @change="changeEdit" v-if="editable"></md-checkbox>
            <md-checkbox v-model="layerPerms" @change="changeEdit" v-else disabled></md-checkbox>
        </md-layout>
    </md-layout>
    <span class="md-body-1">{{layer.title}}</span>
</md-list-item>
</template>

<script>
import { db } from '@/main';
import { mapGetters } from 'vuex';

const CollaboratorsNav = {
    name: 'CollaboratorsNav',
    props: ['layer', 'editable', 'collaborator'],
    data: function() {
        return {
            layerPerms: this.collaborator.layers[this.layer.id]
        };
    },
    computed: {
        ...mapGetters([
            'project'
        ])
    },
    watch: {
        collaborator() {
            this.layerPerms = this.collaborator.layers[this.layer.id];
        }
    },
    methods: {
        changeEdit() {
            this.$nextTick(() => {
                db.collection('projects').doc(this.project.id).update({
                    ['collaborators.' + this.collaborator.uid + '.layers.' + this.layer.id]: this.layerPerms
                });
            });
        }
    },

    mounted: function() {}
};
export default CollaboratorsNav;

</script>


// WEBPACK FOOTER //
// layer-permission.vue?2dd0faa0